<!-- @veltra/icons generated sha256:fc11e5a88a6d8b20 gen:8 source:src/svg/normal/chart-pie.svg -->
<script setup lang="ts">
defineOptions({ name: 'ChartPie' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0m-1.02.5H8.494a.99.99 0 0 1-.994-.994V2.02a6 6 0 1 0 6.48 6.48m0-1A6 6 0 0 0 8.5 2.02v4.497c0 .553.43.983.983.983z"
    />
  </svg>
</template>
